import type { Dispatch } from 'react';
import type { TFunction } from 'i18next';
import { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, showDeleteDialog } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

type useMailsTableColumnsType = (params: {
	dispatch: Dispatch<any>;
	t: TFunction;
	updateRefresh: VoidFunction;
	showButtons?: boolean;
}) => GridColDef[];

const useMailsTableColumns: useMailsTableColumnsType = ({ dispatch, t, updateRefresh, showButtons }) => {
	const columns: GridColDef[] = [
		{
			field: 'mail_title',
			headerName: t('DETAILS_MAILS_FIELD_TITLE'),
			minWidth: 200,
			flex: 1,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			sortable: false,
			hideable: false
		},
		{
			field: 'mail_description',
			headerName: t('DETAILS_MAILS_FIELD_DESCRIPTION'),
			minWidth: 200,
			flex: 1,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			sortable: false
		},
		{
			field: 'mail_table_uid',
			headerName: t('DETAILS_MAILS_FIELD_ITEM'),
			minWidth: 200,
			flex: 2,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({
					value:
						row.mail_table === 'users'
							? row.user_title
							: `${row.comp_title || ''}${row.comp_title && row.peop_title ? ' - ' : ''}${row.peop_title || ''}`,
					to: { module: row.mail_table, uid: value }
				}),
			sortable: false,
			hideable: false
		}
	];

	const editMail = model => {
		dispatch(
			showFastAddDialog({
				module: 'mails',
				isUpdate: true,
				model,
				maxDialogWidth: 'sm',
				updateRefresh,
				additionalProps: { disableIdentityAssociation: true }
			})
		);
	};

	const deleteMail = model =>
		dispatch(
			showDeleteDialog({
				module: 'mails',
				id: model.mail_uid,
				title: model.mail_title,
				updateRefresh
			})
		);

	if (showButtons) {
		return [
			...columns,
			{
				field: 'actions',
				type: 'actions',
				getActions: ({ row }) => [
					<GridActionsCellItem
						icon={<Icon icon="edit" />}
						label={t('ACTION_EDIT')}
						onClick={() => editMail(row)}
					/>,
					<GridActionsCellItem
						icon={<Icon icon="delete" />}
						label={t('ACTION_DELETE')}
						onClick={() => deleteMail(row)}
					/>
				]
			}
		];
	}

	return columns;
};

export default useMailsTableColumns;
